<div class="breadcrumb">
	<div class="home flex flex-row items-center justify-start">
		<mat-icon class="icon-home material-icons-outlined" (click)="viewSelected(home)">home</mat-icon>
	</div>
	<div
		class="next flex items-center justify-start cursor-pointer"
		*ngFor="let element of nameElements; let i = index"
		(click)="viewSelected(element)"
	>
		<mat-icon class="icon-row mr-1">arrow_forward_ios</mat-icon>
		<span
			class="font-lato text-sm hover:text-primary-color truncate"
			[title]="element.text"
			[ngClass]="{ 'text-primary-color': i === nameElements.length - 1 }"
		>
			{{ element.text | titlecase }}
		</span>
	</div>
</div>
